import { devices } from '@helpers/utils.js';
import { ImageAsBackgroundSaveBlock } from '../index';
const ImageGradientSave = ({
  imageGradientBackgroundOptions,
  blockId,
  defaultBlockCssClass,
  printBackgroundStyles,
}) => {
  const classNames = 'bg-img-color';
  const imageAsBackgroundOptions = imageGradientBackgroundOptions;
  return (
    <>
      <ImageAsBackgroundSaveBlock
        {...{ classNames, devices, imageAsBackgroundOptions }}
      />
      <style>
        {devices.map((device) => {
          const deviceType = device.type;
          const gradientSettings =
            imageGradientBackgroundOptions[deviceType].settings;
          const gradientDirection = gradientSettings.gradientDirection || '';
          const gradientColorOne = gradientSettings.gradientColorOne || '';
          const gradientColorTwo = gradientSettings.gradientColorTwo || '';
          const gradientColorOneLocation =
            gradientSettings.gradientColorOneLocation !== undefined
              ? `${gradientSettings.gradientColorOneLocation}%`
              : '';
          const gradientColorTwoLocation =
            gradientSettings.gradientColorTwoLocation !== undefined
              ? `${gradientSettings.gradientColorTwoLocation}%`
              : '';

          let cssCode = '';
          const printQuery = printBackgroundStyles
            ? `, print and (max-width: ${imageGradientBackgroundOptions[deviceType].breakpoint}px)`
            : ``;

          if (gradientColorOne && gradientColorTwo) {
            cssCode = `@media only screen and (max-width: ${imageGradientBackgroundOptions[deviceType].breakpoint}px)${printQuery} {
						.${defaultBlockCssClass}.${defaultBlockCssClass}-${blockId} {
							background-image: linear-gradient(${gradientDirection}deg, ${gradientColorOne} ${gradientColorOneLocation}, ${gradientColorTwo} ${gradientColorTwoLocation});
						}
					}`;
          }

          return cssCode;
        })}
      </style>
    </>
  );
};

export default ImageGradientSave;
